import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import { CreditCardProviderInlineCreatePresenter } from '@webapp/modules/vendor'
import messages from './messages'

// Owned by platform/banking alongside the feature set; re-exported here
// because the route registry imports page params from the page.
export {
  ManageBankCreditCardAccountsTabs,
  type ManageBankCreditCardAccountsParams,
} from '@webapp/platform/banking/feature-sets/ManageBankCreditCardAccountsView/ManageBankCreditCardAccountsTabs'

const ManageBankCreditCardAccountsViewChunk = lazy(() =>
  import('@webapp/platform/banking/feature-sets/ManageBankCreditCardAccountsView').then(
    ({ ManageBankCreditCardAccountsView }) => ({
      default: ManageBankCreditCardAccountsView,
    })
  )
)

export const ManageBankCreditCardAccountsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(
        messages.manageBankCreditCardAccountsPageTitle
      )}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(
            messages.manageBankCreditCardAccountsPageTitle
          ),
        },
      ]}
    >
      <ManageBankCreditCardAccountsViewChunk
        renderProviderInlineCreate={(props) => (
          <CreditCardProviderInlineCreatePresenter {...props} />
        )}
      />
    </Page>
  )
}
